/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Steps from '../../steps';
import Styles from './index.module.css';

export default function LoginRadio({
  className,
  step,
  onChangeStep,
  ...props
}) {
  return (
    <div className={classNames(Styles.mainContainer, className)} {...props}>
      <button
        type="button"
        value={Steps.Register}
        className={classNames(
          Styles.radioButton,
          { [Styles.radioButtonSelected]: step === Steps.Register },
        )}
        onClick={() => onChangeStep(Steps.Register)}
      >
        註冊資料
      </button>
      <button
        type="button"
        value={Steps.Login}
        className={classNames(
          Styles.radioButton,
          { [Styles.radioButtonSelected]: step === Steps.Login },
        )}
        onClick={() => onChangeStep(Steps.Login)}
      >
        登入資料
      </button>
    </div>
  );
}

LoginRadio.propTypes = {
  step: PropTypes.string,
  onChangeStep: PropTypes.func,
  className: PropTypes.string,
};

LoginRadio.defaultProps = {
  step: '',
  onChangeStep: () => {},
  className: '',
};
